export default __webpack_public_path__ + "media/images/landing-4-550x420-53e3b8881016a541785d7b062a259ef9.jpg";